import httpClient from "@insightfulscience/shared-utils/http-client";

const sgApiConnection = (fetchFn, baseUrl) => httpClient(fetchFn, { baseUrl, mode: "cors" });

export default sgApiConnection;
